import React, { useState, useEffect } from "react";
import "./index.scss";

type SwitchButtonProps = {
  onChange: (checked: boolean) => void;
  checked?: boolean;
};

const SwitchButton = ({ onChange, checked = false }: SwitchButtonProps) => {
  const [isChecked, setChecked] = useState(checked);
  useEffect(() => {
    setChecked(checked)
  }, [checked])
  return (
    <label className="switch">
      <input
        type="checkbox"
        onChange={(e) => {
          setChecked(e.target.checked);
          onChange(e.target.checked);
        }}
        checked={isChecked}
      />
      <span className="slider round"></span>
    </label>
  );
};

export default SwitchButton;
